import * as React from "react";
import { CandyTooltip, PopupPositionsType, TooltipTrigger } from "react-ui";
import { IconWeight } from "@skbkontur/icons";

import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { useMetrics } from "../../Internals/Metrics/MetricsProviderContext";
import { HELPTOOLTIP_SHOW } from "../../metricsAction";
import { useCandyTheme } from "../../Internals/ThemeProvider/CandyTheme/UseCandyTheme";
import { InternalIcon } from "../../Icons/Icon";

import { IconWrapper, Root, TooltipContent } from "./HelpTooltip.styles";

export interface HelpTooltipProps {
    children?: React.ReactChild;
    marginLeft?: string | number;
    pos?: PopupPositionsType;
    trigger?: TooltipTrigger;
    value?: string;
    text?: string;
    size?: 16 | 20 | 24;
    color?: string;
    width: number | string;
    weight?: IconWeight;
    for?: AbsoluteModelPath;
}

export function HelpTooltip(props: HelpTooltipProps): JSX.Element {
    const track = useMetrics();
    const theme = useCandyTheme();

    const renderContent = () => {
        track(HELPTOOLTIP_SHOW, { trigger: props.trigger ?? "hover", for: props.for ?? "" });
        return <TooltipContent>{props.children ?? props.value}</TooltipContent>;
    };

    return (
        <Root cursor={props.trigger === "click" ? "pointer" : "help"} marginLeft={props.marginLeft ?? 8}>
            <CandyTooltip
                pos={props.pos ?? "top left"}
                render={renderContent}
                trigger={props.trigger}
                width={props.width ?? 200}>
                <IconWrapper>
                    <InternalIcon
                        name="QuestionCircleIcon"
                        size={props.size ?? theme.typography.primary.fontSize.getNumber()}
                        color={props.color ?? theme.semanticColors.action.color}
                        weight={props.weight}
                    />
                    {props.text && <>&nbsp;</>}
                    {props.text}
                </IconWrapper>
            </CandyTooltip>
        </Root>
    );
}
